module.exports = __webpack_public_path__ + "img/saks6.ca2d7d5a.jpg";